export default __webpack_public_path__ + "static/media/logo5.10704dd6.png";